import {css, StyleSheet} from 'aphrodite';
import React, {ReactNode} from 'react';

import {DEFAULT_HEIGHT, DEFAULT_WIDTH} from 'molbio/components/visualizations/SequenceVisualizationConstants';
import * as FontConstants from 'styles/FontConstants';

interface VisualizationContainerProps {
  children: ReactNode;
  width: number;
  height: number;
}

export default function VisualizationContainer({
  children,
  width,
  height,
}: VisualizationContainerProps): JSX.Element {
  return (
    <svg
      className={css(styles.visualizationContainer)}
      viewBox={`0 0 ${DEFAULT_WIDTH} ${DEFAULT_HEIGHT}`}
      width={width}
      height={height}
    >
      {children}
    </svg>
  );
}

const styles = StyleSheet.create({
  visualizationContainer: {
    fontFamily: FontConstants.FONT_FAMILY_MONOSPACED,
    overflow: 'visible',
  },
});
